var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcVod = function SvgIcVod(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "ic_vod_svg__st0",
    cx: 12,
    cy: 12,
    r: 12
  })), /*#__PURE__*/React.createElement("path", {
    d: "m15.1 11.1-5.2-3c-.7-.4-1.5.1-1.5.9v6c0 .8.8 1.3 1.5.9l5.2-3c.7-.4.7-1.4 0-1.8z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgIcVod;